import React, { useEffect, useState } from 'react';
// @ts-ignore
import { Editor } from 'react-draft-wysiwyg';
import { convertToRaw, EditorState, ContentState } from 'draft-js';
// @ts-ignore
import draftToHtml from 'draftjs-to-html';
// @ts-ignore
import htmlToDraft from 'html-to-draftjs';
import RichText from '../RichText/RichText';

interface Props {
	name: string;
	isRequired?: boolean;
	placeholder?: string;
	value?: string;
	onChange?: (value: string) => void;
}

const RichTextPHP: React.FC<Props> = ({ name, onChange, value }) => {
	const [editorState, setEditorState] = useState<EditorState>();

	return (
		<>
			<RichText
				value={value}
				onChange={onChange}
				onEditorStateLoad={setEditorState}
			/>
			{editorState && (
				<textarea
					style={{ display: 'none' }}
					name={name}
					value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
				/>
			)}
		</>
	);
};

export default RichTextPHP;
